import React from "react";
import "./Loretechls.css";

export default function Loretechls() {
  return (
    <section className="loretechls-section" id="loretechls">
      <div className="slider-wrapper">
        <div className="slider-track">
          {/* Repetição para efeito infinito */}
          <span className="logo-text">LORETECH.LS</span>
          <span className="logo-text">LORETECH.LS</span>
          <span className="logo-text">LORETECH.LS</span>
          <span className="logo-text">LORETECH.LS</span>

          {/* Duplicação invisível para looping suave */}
          <span className="logo-text">LORETECH.LS</span>
          <span className="logo-text">LORETECH.LS</span>
          <span className="logo-text">LORETECH.LS</span>
          <span className="logo-text">LORETECH.LS</span>
        </div>
      </div>
    </section>
  );
}
